module.exports = __webpack_public_path__ + "static/media/blur_recipe_category_small.2ed8b418.jpg";